module.exports = __webpack_public_path__ + "static/img/title.b664bf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/raz_frauenfeld/title.jpg
// module id = 448
// module chunks = 1